module.exports = __webpack_public_path__ + "static/media/6_of_spades.dd29ca5a.svg";